// extracted by mini-css-extract-plugin
module.exports = {"mainReviewsWrapper":"Am-z"};